// Mirrors App\Models\Order::serialFor on the backend.
export const getOrderSerial = (order) => {
    if (!order) return '';
    for (const key of ['code', 'reference']) {
        const value = order[key];
        if (typeof value === 'string' && value.trim() !== '') return value;
    }
    return order.id != null && order.id !== '' ? `#${order.id}` : '';
};

// Work card payloads carry `order_code` / `order_id` instead of `code` / `id`.
export const workCardSerial = (data) => {
    if (!data) return '';
    if (typeof data.order_code === 'string' && data.order_code.trim() !== '') return data.order_code;
    return data.order_id != null && data.order_id !== '' ? `#${data.order_id}` : '';
};
